import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '~/store/user/middlewares'
import { UserState } from '~/store/user/types'
import { ls } from '~/utils/localStorage'

const useSession = () => {
  const { isAuth } = useSelector<any, UserState>((state) => state)

  const dispatch = useDispatch()

  const {
    id,
    first_name,
    last_name,
    email,
    phone,
    currency_id,
    language_id,
    roles,
  }: any = ls.get('user')

  const isValidSession = useMemo(
    () => isAuth !== false && !!email,
    [isAuth, email]
  )

  useEffect(() => {
    if (isAuth === false) {
      dispatch(logout())
    }
  }, [isAuth])

  return {
    isValidSession,
    userData: {
      id,
      first_name,
      last_name,
      email,
      phone,
      currency_id,
      language_id,
      roles,
    },
  }
}

export default useSession
